'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "remove-from-dashboard-modal" */'dashboard-components/report-actions/modals/RemoveFromDashboardModal').then(module => module.RemoveReportFromDashboardDialogContainer);
export default Loadable({
  loader,
  LoadingComponent: () => null
});